<template>
  <div class="about">
    <!-- <div class="banner"></div> -->
    <div class="body">
      <div class="title">
        <div class="a-t">关于我们 <span>/ ABOUT US</span></div>
        <ul class="nav clearfix">
          <li><router-link :to="{ path: '/about/profile' }">基金会简介</router-link></li>
          <li><router-link :to="{ path: '/about/reveal' }">荣誉展示</router-link></li>
          <li><router-link :to="{ path: '/about/event' }">大事记</router-link></li>
          <li><router-link :to="{ path: '/about/org' }">组织架构</router-link></li>
          <li><router-link :to="{ path: '/about/party' }">党建工作</router-link></li>
          <li><router-link :to="{ path: '/about/info' }">信息公开</router-link></li>
        </ul>
      </div>
      <div class="content">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'about',
  components: {
  }
}
</script>
<style lang="scss">
  @import '../../scss/views/about';
</style>